"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.directMessages.loadFailed': 'Impossibile caricare i messaggi diretti.',
    'whatsapp.directMessages.search': 'Cerca contatti...',
    'whatsapp.directMessages.contacts': 'Contatti',
    'whatsapp.directMessages.noContacts': 'Nessun contatto di messaggi diretti trovato.',
    'whatsapp.directMessages.trackLogs': 'Log di tracciamento',
    'whatsapp.directMessages.selectContact': 'Seleziona un contatto per visualizzare i log di tracciamento.',
    'whatsapp.directMessages.noLogs': 'Nessun log di tracciamento per questo contatto.',
    'whatsapp.directMessages.viewDetails': 'Vedi dettagli',
};
